<template>
  <div>
    <b-modal
      :ref="modalId" :id="modalId" size="xl"
      :modal-class="'is-draggable'"
      @shown="prepararDrag"
      scrollable centered :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      @ok="onEventOk"
      @cancel="onEventCancel"
      @hide="resetModal"
      :cancel-title="$t('Shared.BtnCancel')"
      @show="prepararDrag"
    >
      <Loading v-bind:IsLoading="Load" />
      <div class="row">
        <div class="col-md-12">
          <div class="flex-container">
            <div class="row">
              <div class="col-md-3">
                <MdCheckBox
                  v-bind:Label="$t('Shared.SelectAll')"
                  v-bind:Name="'SelectTableAll'"
                  v-bind:ClassProp="'AlignCheck mx-3'"
                  v-bind:CheckedValue="true"
                  v-bind:isReadOnly="totalRows === 0"
                  v-bind:UncheckedValue="false"
                  v-model="UseSelectTableAll"
                  v-on:change="onChangeSelectAll"
                />
              </div>
              <div class="col-md-3 mt-3">
                <span class="tableSelectedItems">
                  <span class="selItemsVal">{{ SelectedRecords }}</span>
                  {{ $t('claimbatchList.item') }}<span v-if="SelectedRecords != 1">s</span>
                  {{ $t('Shared.selected') }}
                </span>
              </div>
              <div class="col-md-6">
                <div class="textlabel" :data-label="$t('Shared.SearchElements')">
                  <div class="input-group" dir="ltr">
                    <input
                      type="text"
                      class="form-control"
                      :dir="dirInput"
                      v-model="parameter.SearchCriteria"
                      @keyup.enter="Search()"
                      ref="inputSearchCriteria"
                    >
                    <div class="input-group-append">
                      <MdButton
                        v-bind:Name="'btnsearchinput'"
                        v-bind:VariantProp="'btn btn-sm search-attached'"
                        v-bind:IconClass="'mdi mdi-magnify'"
                        v-on:click="Search()"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <b-table
            :items="items"
            :fields="fields"
            :show-empty="ShowMessageIsEmpty"
            @row-clicked="onRowClicked"
            @row-dblclicked="onRowDblClicked"
            :tbody-tr-class="tbodyRowClass"
            class="medezTables cutescroll"
            :empty-text="$t('MdTable.nRecShow')"
            responsive
          />

          <b-row dir="ltr">
            <b-col sm="7" md="6" class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
                @change="pageChanged"
              />
            </b-col>
            <b-col align="right" class="mr-2">
              <b-form-group>
                {{ $t('Shared.Show') }}
                <b-form-select
                  v-model="perPage"
                  id="perPageSelect"
                  size="sm"
                  :options="pageOptions"
                  style="width:auto;"
                  @change="PerPageFunction"
                />
                {{ $t('Shared.Of') }} {{ totalRows }}
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>

      <template #modal-title>
        <div class="custom-modal-header">{{ TitleWindow }}</div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import ModalService from '@/services/modal.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import Loading from '@/components/template/loading/Loading'
import Utils from '@/common/utils'
import { EventBus } from '@/event-bus.js';

export default {
  mixins: [ShowMessage],
  components: { Loading },
  props: {
    Fields: Array,
    TypeOption: String,
    Resource: String,
    TitleWindow: String,
    FieldCode: String,
    FieldDescription: String,
    ModalId: String,
    AuxFields: Array,
    Stacked: [Boolean],
    FieldsDate: Array,
    ShowAddRecord: Boolean,
    AddRecordLabel: String,
    BackToGridEventName: String,
    OkEventName: String,
    valueToSearch: String,
    ModelCode: Array,
    ReturnAll: Boolean,
  },

  watch: {
    ModalId(newId) {
      if (newId) this.modalId = newId;
    },
  },

  data() {
    return {
      modalId: this.ModalId || 'bv-modal-multiselect-server',
      ShowMessageIsEmpty: false,
      parameter: {
        SearchCriteria: '',
        PageNumber: 1,
        PageSize: 5,
      },
      fields: this.Fields,
      Header: {},
      pageOptions: [5, 10, 15],
      totalRows: 0,
      currentPage: 1,
      perPage: 5,
      items: [],
      // Persists selection across pages: { [itemCode]: itemObject (ReturnAll) | true (code-only) }
      selectedMap: {},
      SelectedRecords: 0,
      UseSelectTableAll: false,
      Load: true,
      dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
    };
  },

  methods: {
    tbodyRowClass(item) {
      if (!item) return [];
      return item.selected
        ? ['b-table-row-selected', 'table-active', 'cursor-pointer']
        : ['cursor-pointer'];
    },

    onRowClicked(item) {
      const code = item[this.FieldCode];
      if (item.selected) {
        this.$delete(this.selectedMap, code);
        this.$set(item, 'selected', false);
      } else {
        this.$set(this.selectedMap, code, this.ReturnAll ? item : true);
        this.$set(item, 'selected', true);
      }
      this.SelectedRecords = Object.keys(this.selectedMap).length;
      EventBus.$emit('rowClicked', item);
    },

    // Select All fetches every record matching the current search from the API
    onChangeSelectAll(v) {
      if (v) {
        this.getAllData();
      } else {
        this.selectedMap = {};
        this.SelectedRecords = 0;
        this.items.forEach(item => this.$set(item, 'selected', false));
      }
    },

    // After any page load, mark visible items that are already in selectedMap
    markCurrentPageItems() {
      this.items.forEach(item => {
        const code = item[this.FieldCode];
        if (Object.prototype.hasOwnProperty.call(this.selectedMap, code)) {
          this.$set(item, 'selected', true);
          if (this.ReturnAll) {
            this.$set(this.selectedMap, code, item);
          }
        } else {
          this.$set(item, 'selected', false);
        }
      });
    },

    Search() {
      this.currentPage = 1;
      this.UseSelectTableAll = false;
      this.getData();
    },

    pageChanged(page) {
      this.currentPage = page;
      this.getData();
    },

    PerPageFunction(perPage) {
      this.perPage = perPage;
      this.currentPage = 1;
      this.getData();
    },

    async getData() {
      if (!this.Resource) return;
      this.parameter.PageNumber = this.currentPage;
      this.parameter.PageSize = this.perPage;
      this.Load = true;
      try {
        const response = await ModalService.getAll(this.Resource, this.parameter);
        if (response.status === 200 && response.data) {
          this.items = response.data;
          this.applyFieldsDate();
          const headerString = response.headers['x-pagination'];
          if (headerString) {
            this.Header = JSON.parse(headerString);
            this.totalRows = this.Header.TotalCount;
          } else {
            this.totalRows = this.items.length;
          }
          this.ShowMessageIsEmpty = this.items.length === 0;
          this.markCurrentPageItems();
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.Load = false;
      }
    },

    // Fetches all results (no PageNumber/PageSize) to populate selectedMap for Select All
    async getAllData() {
      if (!this.Resource) return;
      this.Load = true;
      try {
        const params = { SearchCriteria: this.parameter.SearchCriteria };
        const response = await ModalService.getAll(this.Resource, params);
        if (response.status === 200 && response.data) {
          response.data.forEach(item => {
            const code = item[this.FieldCode];
            this.$set(this.selectedMap, code, this.ReturnAll ? item : true);
          });
          this.SelectedRecords = Object.keys(this.selectedMap).length;
          this.markCurrentPageItems();
        }
      } catch (error) {
        this.handleError(error);
        this.UseSelectTableAll = false;
      } finally {
        this.Load = false;
      }
    },

    applyFieldsDate() {
      if (!this.FieldsDate) return;
      this.items.forEach(element => {
        this.FieldsDate.forEach(fieldDate => {
          if (Utils.isValidDate(element[fieldDate])) {
            element[fieldDate] = Utils.formatterDateToString(element[fieldDate]);
          }
        });
      });
    },

    handleError(error) {
      if (!error.response) {
        this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.RetrieveInformation'), 'error');
      } else {
        this.showMessage(this.$tc('Msg.Error'), error, 'error');
      }
    },

    // Pre-seed selectedMap from previously selected codes passed via ModelCode prop
    seedSelectedFromModelCode() {
      if (!this.ModelCode || this.ModelCode.length === 0) return;
      this.ModelCode.forEach(code => {
        if (!Object.prototype.hasOwnProperty.call(this.selectedMap, code)) {
          // Store a partial stub; updated with the full item when the item is paged in
          this.$set(this.selectedMap, code, this.ReturnAll ? { [this.FieldCode]: code } : true);
        }
      });
      this.SelectedRecords = Object.keys(this.selectedMap).length;
    },

    emitEventOK() {
      const result = this.ReturnAll
        ? Object.values(this.selectedMap)
        : Object.keys(this.selectedMap);
      this.$emit('getCodeConditionOK', result);
      this.ResetProps();
      if (result.length > 0) {
        EventBus.$emit('IsCorrectCode', true);
      }
    },

    emitEventCancel() {
      this.$emit('getCodeConditionCancel');
      this.ResetProps();
    },

    ResetProps() {
      this.items = [];
      this.selectedMap = {};
      this.SelectedRecords = 0;
      this.UseSelectTableAll = false;
      this.parameter.SearchCriteria = '';
    },

    resetModal() {
      this.parameter.SearchCriteria = '';
    },

    onRowDblClicked(item) {
      const code = item[this.FieldCode];
      if (!Object.prototype.hasOwnProperty.call(this.selectedMap, code)) {
        this.$set(this.selectedMap, code, this.ReturnAll ? item : true);
        this.$set(item, 'selected', true);
        this.SelectedRecords = Object.keys(this.selectedMap).length;
      }
      this.emitEventOK();
    },

    onEventOk() {
      this.emitEventOK();
    },

    onEventCancel() {
      this.emitEventCancel();
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    focusInput() {
      if (this.$refs.inputSearchCriteria)
        this.$refs.inputSearchCriteria.focus();
      if (this.valueToSearch) {
        this.parameter.SearchCriteria = this.valueToSearch;
        this.Search();
      }
    },

    prepararDrag() {
      this.$nextTick(() => {
        const outer = document.getElementById(`${this.ModalId}___BV_modal_outer_`);
        if (!outer) return;
        const dialog = outer.querySelector('.modal-dialog');
        const header = outer.querySelector('.modal-header');
        if (!dialog || !header) return;
        if (outer.classList.contains('is-draggable')) return;
        header.style.cursor = 'move';
        header.onmousedown = (e) => {
          e.preventDefault();
          const rect = dialog.getBoundingClientRect();
          const offsetX = e.clientX - rect.left;
          const offsetY = e.clientY - rect.top;
          dialog.style.width = `${rect.width}px`;
          dialog.style.height = `${rect.height}px`;
          dialog.style.position = 'fixed';
          dialog.style.left = `${rect.left}px`;
          dialog.style.top = `${rect.top}px`;
          dialog.style.margin = 0;
          dialog.style.transform = 'none';
          const moveHandler = (eMove) => {
            dialog.style.left = `${eMove.clientX - offsetX}px`;
            dialog.style.top = `${eMove.clientY - offsetY}px`;
          };
          document.addEventListener('mousemove', moveHandler);
          document.addEventListener('mouseup', () => document.removeEventListener('mousemove', moveHandler), { once: true });
        };
      });
    },
  },

  mounted() {
    this.$root.$on('bv::modal::shown', async (bvEvent, modalId) => {
      if (modalId !== this.modalId) return;
      this.currentPage = 1;
      this.parameter.PageNumber = 1;
      this.seedSelectedFromModelCode();
      await this.getData();
      this.$nextTick(() => {
        setTimeout(() => this.focusInput(), 500);
      });
    });
  },
};
</script>
